import { getCookie, setCookie } from "../utils";

(function ($) {    

    var topBannerClosedCookieName = 'sm_agw_banner_closed';

    if (!getCookie(topBannerClosedCookieName)) {
        $('body').addClass('with-top-banner');
    }

    $('#top-banner-close').on('click', function() {
        setCookie(topBannerClosedCookieName, 1, 9999);
        $('body').removeClass('with-top-banner');
    })

})(window.jQuery)
